import ACTIONS from "../actions/types";
import { textTranslate } from "../../utils/i18n";

const initialState = {
  maniView: "",
  viewMode: "", //servicesViewModes.table
  statusList: [
    { _id: "1", name: textTranslate("active"), value: true },
    { _id: "2", name: textTranslate("inactive"), value: false },
  ],
  techniciansList: [],
  isFetchingTechniciansList: true,
  isFetchingServiceCentersList: false,
  isFetchingSpecificServiceCenter: true,
  isFetchingServiceCenterTechnicians: true,
  selectedServiceCenterTechniciansList: [],
  selectedServiceCenter: {},
  serviceCentersList: [],
  ownersList: [],
  orderStatusList: [],
  selectedTechnicianDetails: {},
};

const servicesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTIONS.SERVICES.SET_MAIN_VIEW:
      return {
        ...state,
        maniView: payload,
      };

    case ACTIONS.SERVICES.SET_VIEW_MODE:
      localStorage.setItem("preferredViewMode", payload);
      return {
        ...state,
        viewMode: payload,
      };

    case ACTIONS.SERVICES.FETCH_ALSERVICE_CENTERER_START:
      return {
        ...state,
        serviceCentersList: [],
        isFetchingServiceCentersList: true,
      };
    case ACTIONS.SERVICES.FETCH_ALL_SERVICE_CENTER_SUCCESS:
      return {
        ...state,
        serviceCentersList: [...payload],
        isFetchingServiceCentersList: false,
      };
    case ACTIONS.SERVICES.FETCH_ALL_SERVICE_CENTER_FAILURE:
      return {
        ...state,
        serviceCentersList: [],
        isFetchingServiceCentersList: false,
        errorMessage: payload,
      };

    case ACTIONS.SERVICES.ADD_NEW_SUCCESS:
      return {
        ...state,
        serviceCentersList: [...state.serviceCentersList, { ...payload }],
      };
    case ACTIONS.SERVICES.ADD_NEW_FAILURE:
      return {
        ...state,
      };

    case ACTIONS.SERVICES.FETCH_SPECIFIC_SERVICE_CENTERER_START:
      return {
        ...state,
        isFetchingSpecificServiceCenter: true,
        selectedServiceCenter: {},
      };

    case ACTIONS.SERVICES.FETCH_SPECIFIC_SERVICE_CENTER_SUCCESS:
      return {
        ...state,
        isFetchingSpecificServiceCenter: false,
        selectedServiceCenter: { ...payload },
      };

    case ACTIONS.SERVICES.FETCH_SPECIFIC_SERVICE_CENTER_FAILURE:
      return {
        ...state,
        isFetchingSpecificServiceCenter: false,
        selectedServiceCenter: {},
        errorMessage: payload,
      };

    case ACTIONS.SERVICES.FETCH_SERVICE_CENTER_TECHNICIANS_START:
      return {
        ...state,
        isFetchingServiceCenterTechnicians: true,
        selectedServiceCenterTechniciansList: [],
      };
    case ACTIONS.SERVICES.FETCH_SERVICE_CENTER_TECHNICIANS_SUCCESS:
      return {
        ...state,
        isFetchingServiceCenterTechnicians: false,
        selectedServiceCenterTechniciansList: [...payload],
      };
    case ACTIONS.SERVICES.FETCH_SERVICE_CENTER_TECHNICIANS_FAILURE:
      return {
        ...state,
        isFetchingServiceCenterTechnicians: false,
        selectedServiceCenterTechniciansList: [],
      };
    case ACTIONS.SERVICES.SET_SELECTED_TECHNICIAN:
      return {
        ...state,
        selectedTechnician: { ...payload },
      };

    case ACTIONS.SERVICES.REMOVE_TECHNICIAN_FROM_CENTER_START:
      return {
        ...state,
        isFetchingServiceCenterTechnicians: true,
      };
    case ACTIONS.SERVICES.REMOVE_TECHNICIAN_FROM_CENTER:
      return {
        ...state,
        isFetchingServiceCenterTechnicians: false,
        selectedServiceCenterTechniciansList: state.selectedServiceCenterTechniciansList.filter(
          (t) => t._id !== payload.selectedTechnician._id
        ),
      };
    case ACTIONS.SERVICES.REMOVE_TECHNICIAN_FROM_CENTER_FALURE:
      return {
        ...state,
        isFetchingServiceCenterTechnicians: false,
      };

    case ACTIONS.SERVICES.DEACTIVATE_TECHNICIAN_FROM_CENTER_START:
      return {
        ...state,
        isFetchingServiceCenterTechnicians: true,
      };
    case ACTIONS.SERVICES.DEACTIVATE_TECHNICIAN_FROM_CENTER:
      return {
        ...state,
        isFetchingServiceCenterTechnicians: false,
        selectedServiceCenterTechniciansList: state.selectedServiceCenterTechniciansList.map((t) =>
          t._id === payload.selectedTechnician._id ? { ...t, isActive: !t.isActive } : { ...t }
        ),
      };
    case ACTIONS.SERVICES.DEACTIVATE_TECHNICIAN_FROM_CENTER_FALURE:
      return {
        ...state,
        isFetchingServiceCenterTechnicians: false,
      };

    case ACTIONS.SERVICES.UPDATE_SERVICE_CENTER_START:
      return {
        ...state,
        isFetchingSpecificServiceCenter: true,
        isFetchingServiceCenterTechnicians: true,
        // selectedServiceCenter: {},
      };
    case ACTIONS.SERVICES.UPDATE_SERVICE_CENTER:
      return {
        ...state,
        isFetchingSpecificServiceCenter: false,
        isFetchingServiceCenterTechnicians: false,
        selectedServiceCenter: { ...payload.serviceCenter },
      };
    case ACTIONS.SERVICES.UPDATE_SERVICE_CENTER_FALURE:
      return {
        ...state,
        isFetchingSpecificServiceCenter: false,
        isFetchingServiceCenterTechnicians: false,
        // selectedServiceCenter: {},
      };

    case ACTIONS.SERVICES.DELETE_SERVICE_CENTER_START:
      return {
        ...state,
        isFetchingSpecificServiceCenter: true,
      };
    case ACTIONS.SERVICES.DELETE_SERVICE_CENTER:
      return {
        ...state,
        isFetchingSpecificServiceCenter: false,
        selectedServiceCenter: {},
      };
    case ACTIONS.SERVICES.DELETE_SERVICE_CENTER_FALURE:
      return {
        ...state,
        isFetchingSpecificServiceCenter: false,
      };

    case ACTIONS.SERVICES.CREATE_TECHNICIAN_START:
      return {
        ...state,
        isFetchingServiceCenterTechnicians: true,
      };
    case ACTIONS.SERVICES.CREATE_TECHNICIAN:
      return {
        ...state,
        isFetchingServiceCenterTechnicians: false,
        selectedServiceCenterTechniciansList: [...state.selectedServiceCenterTechniciansList, payload],
      };
    case ACTIONS.SERVICES.CREATE_TECHNICIAN_FALURE:
      return {
        ...state,
        isFetchingServiceCenterTechnicians: false,
      };
    case ACTIONS.SERVICES.FETCH_TECHNICIAN_DETAILS_START:
      return {
        ...state,
        isFetchingTechnicianDetails: true,
      };
    case ACTIONS.SERVICES.FETCH_TECHNICIAN_DETAILS:
      return {
        ...state,
        isFetchingTechnicianDetails: false,
        selectedTechnicianDetails: { ...payload },
      };
    case ACTIONS.SERVICES.FETCH_TECHNICIAN_DETAILS_FALURE:
      return {
        ...state,
        isFetchingTechnicianDetails: false,
      };
    case ACTIONS.SERVICES.EDIT_TECHNICIAN_START:
      return { ...state };
    case ACTIONS.SERVICES.EDIT_TECHNICIAN:
      return { ...state };
    case ACTIONS.SERVICES.EDIT_TECHNICIAN_FALURE:
      return { ...state };

    case ACTIONS.SERVICES.FETCH_ALL_TECHNICIANS_START:
      return { ...state, isFetchingTechniciansList: true, techniciansList: [] };
    case ACTIONS.SERVICES.FETCH_ALL_TECHNICIANS_SUCCESS:
      return { ...state, isFetchingTechniciansList: false, techniciansList: [...payload] };
    case ACTIONS.SERVICES.FETCH_ALL_TECHNICIANS_FAILURE:
      return { ...state, isFetchingTechniciansList: false, techniciansList: [] };

    default:
      return { ...state };
  }
};
export default servicesReducer;
